import { useEffect, useState } from "react";
import { BookOpen, Search, ChevronDown, ChevronUp, ExternalLink } from "lucide-react";
import api from "../../lib/api";
import { Collapsible } from "./bits";

const fmtDate = (k) => new Date(k + "T12:00:00").toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" });

export default function JournalView({ onPick, refreshKey }) {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/planner/journals").then(({ data }) => setRows(data)).catch(() => setRows([])); }, [refreshKey]);
  const list = (rows || []).filter((r) => !q.trim() || r.text.toLowerCase().includes(q.toLowerCase()) || r.journal_date.includes(q));
  return (
    <Collapsible title="Journal" icon={BookOpen} testid="journal-view" summary={rows && <span>{rows.length} {rows.length === 1 ? "entry" : "entries"}</span>}>
      <div className="flex items-center gap-2 mb-2">
        <Search className="w-3.5 h-3.5 text-slate-400" /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search your journal…" className="flex-1 text-xs border border-slate-200 rounded-md px-2 py-1" data-testid="journal-search" />
      </div>
      {!rows ? <p className="text-xs text-slate-400">Loading…</p> : list.length === 0 ? <p className="text-xs text-slate-400" data-testid="journal-empty">No journal entries yet — write your End of Day Review and press "Create this day's journal entry".</p> : (
        <div className="space-y-1.5 max-h-[420px] overflow-y-auto pr-1" data-testid="journal-list">
          {list.map((r) => {
            const isOpen = open === r.id;
            return (
              <article key={r.id} className="rounded-lg border border-slate-200 bg-white" data-testid={`journal-entry-${r.journal_date}`}>
                <button onClick={() => setOpen(isOpen ? null : r.id)} className="w-full flex items-center gap-2 px-3 py-2 text-left" data-testid={`journal-entry-toggle-${r.journal_date}`}>
                  <span className="font-display font-bold text-navy-800 text-sm">{fmtDate(r.journal_date)}</span>
                  <span className={`text-[10px] font-bold uppercase ${r.edited ? "text-gold-dark" : "text-slate-400"}`}>{r.edited ? "edited by you" : "AI draft"}</span>
                  <span className="flex-1 text-xs text-slate-500 truncate hidden sm:inline">{!isOpen && r.text.slice(0, 140)}</span>
                  {isOpen ? <ChevronUp className="w-4 h-4 text-slate-400" /> : <ChevronDown className="w-4 h-4 text-slate-400" />}
                </button>
                {isOpen && (
                  <div className="px-3 pb-3">
                    <p className="text-sm text-navy-800 leading-relaxed whitespace-pre-wrap break-words" data-testid={`journal-entry-text-${r.journal_date}`}>{r.text}</p>
                    <button onClick={() => onPick(r.journal_date)} className="mt-2 text-[11px] text-gold-dark font-bold inline-flex items-center gap-1 hover:underline" data-testid={`journal-open-day-${r.journal_date}`}><ExternalLink className="w-3 h-3" /><span>Open that day in the planner</span></button>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      )}
    </Collapsible>
  );
}
